import {
  TARF_INIT_LOADING,
  TARF_INIT_SUCCESS,
  TARF_INIT_FAIL
} from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

export const Tariff = {
  async tariffInit ({ commit, state }) {
    const apiUrl = state.menu.tariff
    commit(TARF_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(TARF_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(TARF_INIT_FAIL, extractMessages(error))
      }
    }
  }
}
